import { SubmissionPrompt } from 'lib/types/generated-types'
import { Disclosure } from '@headlessui/react'
import { IconChevronDown, IconChevronsDown } from '@tabler/icons-react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { useState } from 'react'

export const ContentDisplay = ({
  content,
}: {
  content: (SubmissionPrompt & { name: string })[]
}) => {
  const isDesktop = typeof window !== 'undefined' && window.innerWidth >= 768

  return (
    <div className="flex flex-col gap-4 divide-y divide-slate-200 border bg-white pb-4">
      {content?.map((prompt) => (
        <Disclosure key={prompt.id} defaultOpen={isDesktop}>
          {({ open }) => (
            <div id={`prompt-content-${prompt.prompt_id}`} className="bg-white">
              <Disclosure.Button className="flex w-full items-center justify-between bg-slate-200 px-4 py-2 text-left text-base font-medium text-gray-900 hover:bg-slate-300">
                <span>{prompt.name || 'Untitled Prompt'}</span>
                <IconChevronDown
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-5 w-5 text-gray-500 transition-transform duration-200`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pt-4">
                <TruncatedMarkdown content={prompt.ai_response || ''} />
              </Disclosure.Panel>
            </div>
          )}
        </Disclosure>
      ))}
    </div>
  )
}

const TruncatedMarkdown = ({ content }: { content: string }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div className="relative">
      <div
        className="prose prose-sm max-w-none prose-headings:text-base prose-headings:font-bold prose-headings:text-gray-900 prose-p:leading-normal prose-p:text-gray-600"
        style={{
          display: isExpanded ? 'block' : '-webkit-box',
          WebkitLineClamp: isExpanded ? 'unset' : '10',
          WebkitBoxOrient: 'vertical',
          overflow: isExpanded ? 'visible' : 'hidden',
        }}
      >
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
      </div>
      {!isExpanded && (
        <div
          onClick={() => setIsExpanded(true)}
          className="absolute bottom-0 left-0 right-0 flex cursor-pointer flex-col items-center border-t bg-white bg-opacity-90"
        >
          <span className="flex animate-pulse items-center gap-1 pt-4 text-xs font-medium text-gray-600">
            View more
            <IconChevronsDown className="h-4 w-4" />
          </span>
        </div>
      )}
    </div>
  )
}
